/**
 * Global — script carregado em todas as páginas
 */

import { initAOS }           from '../modules/UI/aos-init.js';
import { initNavbar }        from '../modules/UI/navbar.js';
import { initSearch }        from '../modules/UI/search.js';
import { initFaq }           from '../modules/Components/faq.js';
import { initTicker }        from '../modules/Components/ticker.js';
import { initAccordion }     from '../modules/Components/accordion.js';
import { initTabbedContent } from '../modules/Components/tabbed-content.js';
import { initJobCard }       from '../modules/Components/job-card.js';
import { initColumnsSlider }        from '../modules/Components/columns-slider.js';
import { initBlogRelatedLoadMore }  from '../modules/Components/blog-related-load-more.js';
import { initBlogPostsGridLoadMore } from '../modules/Components/blog-posts-grid-load-more.js';
import { initVideoPlayer }           from '../modules/Components/video-player.js';
import { initOfferCards }            from '../modules/Components/offer-cards.js';
import { initNossosFundosFilter }    from '../modules/Components/nossos-fundos-filter.js';
import { initListaFundos }           from '../modules/Components/lista-fundos.js';
import { initListaFundosListados }   from '../modules/Components/lista-fundos-listados.js';
import { initFundFilter }            from '../modules/Components/fund-filter.js';
import { initFundCardsGridFilter }   from '../modules/Components/fund-cards-grid.js';
import { initCartaLead }             from '../modules/Components/carta-lead.js';

function init() {
	initAOS();
	initNavbar();
	initSearch();
	initFaq();
	initTicker();
	initAccordion();
	initTabbedContent();
	initJobCard();
	initColumnsSlider();
	initBlogRelatedLoadMore();
	initBlogPostsGridLoadMore();
	initVideoPlayer();
	initOfferCards();
	initNossosFundosFilter();
	initListaFundos();
	initListaFundosListados();
	initFundFilter();
	initFundCardsGridFilter();
	initCartaLead();

	// ── Coordenação tipo + visualizacao (Como Investir) ──
	const elListaListados  = document.querySelector('.lista-fundos--listados');
	const elGradeListados  = document.querySelector('.grade-fundos-listados');
	const elListaAbertos   = document.querySelector('.lista-fundos--abertos');
	const elGradeAbertos   = document.querySelector('.grade-fundos-abertos');
	const elPoupah         = document.querySelector('.section-poupah-como-investir');
	const elComoEscolher   = document.querySelector('.section-como-escolher');

	if ( elListaListados || elGradeListados || elListaAbertos || elGradeAbertos || elPoupah ) {
		function atualizarVisibilidade(tipo, visualizacao) {
			const isList  = visualizacao !== 'grade';
			const isGrade = visualizacao === 'grade';

			if (elListaListados)  elListaListados.hidden  = !(tipo === 'listado' && isList);
			if (elGradeListados)  elGradeListados.hidden  = !(tipo === 'listado' && isGrade);
			if (elListaAbertos)   elListaAbertos.hidden   = !(tipo === 'aberto'  && isList);
			if (elGradeAbertos)   elGradeAbertos.hidden   = !(tipo === 'aberto'  && isGrade);
			if (elPoupah)         elPoupah.hidden         = !(tipo === 'poupah');
			if (elComoEscolher)   elComoEscolher.hidden   = tipo === 'poupah';
		}

		document.addEventListener('nossos-fundos-filter:change', (e) => {
			const { state } = e.detail ?? {};
			if (!state) return;
			atualizarVisibilidade(state.tipo, state.visualizacao);
			filtrarPorOperadora(state.operadora);
		});

		function filtrarPorOperadora(operadora) {
			document.querySelectorAll('.lista-fundos__item, .fund-card').forEach(item => {
				if (!operadora) {
					item.style.display = '';
					return;
				}

				// Fundos listados na bolsa não têm corretoras associadas — sempre visíveis.
				if (item.closest('.lista-fundos--listados') || item.closest('.grade-fundos-listados')) {
					item.style.display = '';
					return;
				}

				const ops = (item.dataset.operadoras || '').split(' ').filter(Boolean);
				item.style.display = ops.includes(operadora) ? '' : 'none';
			});
		}
	}
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
